export const LogoIcon = () => {
  return (
    <svg
      width="141"
      height="39"
      viewBox="0 0 141 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4764 8.60747C15.0838 8.60747 18.0351 11.5386 18.0351 15.1661V21.724C18.0351 25.3515 15.0838 28.2818 11.4764 28.2818H0V0.4104H3.27928V8.60747H11.4764ZM11.4764 25.0034C13.2805 25.0034 14.7557 23.5482 14.7557 21.724V15.1661C14.7557 13.3419 13.2805 11.8868 11.4764 11.8868H3.27928V25.0034H11.4764Z"
        fill="#2D2D2B"
      />
      <path
        d="M59.8425 25.003H67.2203V28.2819H49.1855V25.003H56.5635V11.8868H29.5113V25.003H39.3484V28.2819H22.9531V25.003H26.2321V8.60767H59.8425V25.003Z"
        fill="#7F56D9"
      />
      <path
        d="M55.7441 2.0497C55.7441 0.471871 56.2975 0 58.2034 0C60.1303 0 60.6628 0.471871 60.6628 2.0497C60.6628 3.60731 60.1303 4.09941 58.2034 4.09941C56.2774 4.09941 55.7441 3.60731 55.7441 2.0497Z"
        fill="url(#paint0_linear_2_8332)"
      />
      <path
        d="M88.535 0.4104H91.8135V28.2818H80.337C76.7296 28.2818 73.7793 25.3515 73.7793 21.724V15.1661C73.7793 11.5386 76.7296 8.60747 80.337 8.60747H88.535V0.4104ZM88.535 25.0034V11.8868H80.337C78.5337 11.8868 77.0578 13.3419 77.0578 15.1661V21.724C77.0578 23.5482 78.5337 25.0034 80.337 25.0034H88.535Z"
        fill="#2D2D2B"
      />
      <path
        d="M116.407 32.3812C116.407 36.0079 113.456 38.939 109.849 38.939H100.012V35.6596H109.849C111.653 35.6596 113.128 34.2046 113.128 32.3812V28.2818H104.931C101.323 28.2818 98.3721 25.3515 98.3721 21.7239V15.1661C98.3721 11.5385 101.323 8.60742 104.931 8.60742H116.407V32.3812ZM113.128 11.8867H104.931C103.128 11.8867 101.652 13.3418 101.652 15.1661V21.7239C101.652 23.5482 103.128 25.0033 104.931 25.0033H113.128V11.8867Z"
        fill="#2D2D2B"
      />
      <path
        d="M126.244 21.7239C126.244 23.5482 127.719 25.0033 129.523 25.0033H141V28.2818H129.523C125.916 28.2818 122.965 25.3515 122.965 21.7239V15.1661C122.965 11.5385 125.916 8.60742 129.523 8.60742H134.442C138.049 8.60742 141 11.5385 141 15.1661V20.0847H126.244V21.7239ZM129.523 11.8867C127.719 11.8867 126.244 13.3418 126.244 15.1661V16.8053H137.721V15.1661C137.721 13.3418 136.245 11.8867 134.442 11.8867H129.523Z"
        fill="#2D2D2B"
      />
      <path
        d="M25.9336 2.19521C25.9336 0.617379 26.487 0.145508 28.3928 0.145508C30.3189 0.145508 30.8522 0.617379 30.8522 2.19521C30.8522 3.75292 30.3189 4.24492 28.3928 4.24492C26.4659 4.24492 25.9336 3.75292 25.9336 2.19521Z"
        fill="url(#paint1_linear_2_8332)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2_8332"
          x1="55.7441"
          y1="4.09938"
          x2="59.7764"
          y2="-0.738743"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6941C6" />
          <stop offset="1" stopColor="#7F56D9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2_8332"
          x1="25.9335"
          y1="4.24489"
          x2="29.9658"
          y2="-0.593235"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6941C6" />
          <stop offset="1" stopColor="#7F56D9" />
        </linearGradient>
      </defs>
    </svg>
  );
};

